import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import WelcomeNew from '@/views/WelcomeNew'
import Admin from '@/views/admin/Admin'
import AdminCreate from '@/views/admin/AdminCreate'
import AdminUpdate from '@/views/admin/AdminUpdate'
import Role from '@/views/role/Role'
import RoleUpdate from '@/views/role/RoleUpdate'
import Product from '@/views/product/Product'
import ProductCreate from '@/views/product/ProductCreate'
import Service from '@/views/service/Service'
import ServiceCreate from '@/views/service/ServiceCreate'
import App from '@/views/app/App'
import AppUpdate from '@/views/app/AppUpdate'
import AppData from '@/views/app/AppData'
import Demo from '@/views/demo/Demo'
import DemoCreate from '@/views/demo/DemoCreate'
import Project from '@/views/project/Project'
import ProjectData from '@/views/project/ProjectData'
import Stat from '@/views/stat/Stat'
import Tag from '@/views/stat/Tag'
import TagCreate from '@/views/stat/TagCreate'
import Group from '@/views/stat/Group'
import GroupCreate from '@/views/stat/GroupCreate'
import Contact from '@/views/Contact'
import Vote from '@/views/vote/Vote'
import VoteCreate from '@/views/vote/VoteCreate'
import VoteUpdate from '@/views/vote/VoteUpdate'
import VoteItem from '@/views/vote/VoteItem'
import VoteItemCreate from '@/views/vote/ItemCreate'
import VoteItemUpdate from '@/views/vote/ItemUpdate'
import VoteReward from '@/views/vote/VoteReward'
import VoteRewardHistory from '@/views/vote/VoteRewardHistory'
import TestLoginAndVote from '@/views/vote/TestLoginAndVote'
import WelcomeCategory from '@/views/welcomeSetting/Category'
import WelcomeService from '@/views/welcomeSetting/Service'
import WelcomeDemo from '@/views/welcomeSetting/Demo'
import WelcomeCategoryCreate from '@/views/welcomeSetting/CategoryCreate'
import WelcomeCategoryUpdate from '@/views/welcomeSetting/CategoryUpdate'
import WelcomeServiceCreate from '@/views/welcomeSetting/ServiceCreate'
import WelcomeServiceUpdate from '@/views/welcomeSetting/ServiceUpdate'
import WelcomeDemoCreate from '@/views/welcomeSetting/DemoCreate'
import WelcomeDemoUpdate from '@/views/welcomeSetting/DemoUpdate'
import WelcomeDemoDisplay from '@/views/welcomeSetting/DemoDisplay'
import TemplateEdit from '@/views/template/TemplateEdit'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/welcome',
      name: 'homepage',
      meta: { label: '首页' },
      component: Full,
      children: [
        {
          path: 'welcome',
          name: 'welcome',
          meta: { label: '首页' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'welcome-list',
              meta: { label: '服务列表' },
              component: WelcomeNew
            },
            {
              path: ':categoryCode/services/:serviceCode/demos',
              name: 'welcome-demos',
              meta: { label: '样例信息' },
              component: WelcomeDemoDisplay
            }
          ]
        },
        {
          path: 'contact',
          name: 'contact',
          meta: { label: '联系方式' },
          component: Contact
        },
        {
          path: 'admin',
          name: 'admin',
          meta: { label: '管理员' },
          redirect: '/admin/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'admin-list',
              meta: { label: '管理员列表' },
              component: Admin
            },
            {
              path: 'create',
              name: 'admin-create',
              meta: { label: '创建管理员' },
              component: AdminCreate
            },
            {
              path: ':id',
              name: 'admin-update',
              meta: { label: '权限管理' },
              component: AdminUpdate
            }
          ]
        },
        {
          path: 'role',
          name: 'role',
          meta: { label: '角色' },
          redirect: '/role/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'role-list',
              meta: { label: '管理员列表' },
              component: Role
            },
            {
              path: 'create',
              name: 'role-create',
              meta: { label: '创建角色' },
              component: RoleUpdate
            },
            {
              path: ':id',
              name: 'role-update',
              meta: { label: '权限管理' },
              component: RoleUpdate
            }
          ]
        },
        {
          path: 'product',
          name: 'product',
          meta: { label: '产品' },
          redirect: '/product/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'product-list',
              meta: { label: '产品列表' },
              component: Product
            },
            {
              path: 'create',
              name: 'product-create',
              meta: { label: '创建产品' },
              component: ProductCreate
            }
          ]
        },
        {
          path: 'project',
          name: 'project',
          meta: { label: '项目' },
          redirect: '/project/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'project-list',
              meta: { label: '项目列表' },
              component: Project
            },
            {
              path: 'services/:serviceCode/apps/:appCode',
              name: 'project-update',
              meta: { label: '配置管理' },
              component: AppUpdate
            },
            {
              path: 'services/:serviceCode/apps/:appCode/data',
              name: 'project-data',
              meta: { label: '数据查询' },
              component: ProjectData
            }
          ]
        },
        {
          path: 'service',
          name: 'service',
          meta: { label: '服务' },
          redirect: '/service/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'service-list',
              meta: { label: '服务列表' },
              component: Service
            },
            {
              path: 'create',
              name: 'service-create',
              meta: { label: '创建服务' },
              component: ServiceCreate
            },
            {
              path: ':serviceCode',
              name: 'service-update',
              meta: { label: '更新服务' },
              component: ServiceCreate
            },
            {
              path: ':serviceCode/template',
              name: 'template-edit',
              meta: { label: '描述模板' },
              component: TemplateEdit
            }
          ]
        },
        {
          path: 'service/:serviceCode/apps',
          name: 'app',
          meta: { label: '实例' },
          redirect: '/service/:serviceCode/apps',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'app-list',
              meta: { label: '实例列表' },
              component: App
            },
            {
              path: 'create',
              name: 'app-create',
              meta: { label: '创建实例' },
              component: AppUpdate
            },
            {
              path: ':appCode',
              name: 'app-update',
              meta: { label: '更新实例' },
              component: AppUpdate
            },
            {
              path: ':appCode/data',
              name: 'app-data',
              meta: { label: '实例数据' },
              component: AppData
            },
            {
              path: ':appCode/stat',
              name: 'app-stat',
              meta: { label: '数据统计' },
              component: Stat
            }
          ]
        },
        {
          path: 'service/:serviceCode/demos',
          name: 'demo',
          meta: { label: '样例' },
          redirect: '/service/:serviceCode/demos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'demo-list',
              meta: { label: '样例列表' },
              component: Demo
            },
            {
              path: 'create',
              name: 'demo-create',
              meta: { label: '创建样例' },
              component: DemoCreate
            },
            {
              path: ':demoCode',
              name: 'demo-update',
              meta: { label: '更新样例' },
              component: DemoCreate
            }
          ]
        },
        {
          path: 'stat',
          name: 'stat',
          meta: { label: '数据' },
          redirect: '/stat',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'stat-list',
              meta: { label: '数据统计' },
              component: Stat
            },
            {
              path: '/tags',
              name: 'tag-list',
              meta: { label: '标签列表' },
              component: Tag
            },
            {
              path: '/tags/update',
              name: 'tag-update',
              meta: { label: '创建标签' },
              component: TagCreate
            },
            {
              path: '/groups/update',
              name: 'group-update',
              meta: { label: '创建分组' },
              component: GroupCreate
            },
            {
              path: '/groups',
              name: 'group-list',
              meta: { label: '分组列表' },
              component: Group
            }
          ]
        },
        {
          path: 'vote',
          name: 'vote',
          meta: { label: '点赞中心' },
          redirect: '/vote/',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'testPage',
              name: 'test-page',
              meta: { label: '测试登录点赞' },
              component: TestLoginAndVote
            },
            {
              path: '',
              name: 'vote-list',
              meta: { label: '实例列表' },
              component: Vote
            },
            {
              path: 'create',
              name: 'vote-create',
              meta: { label: '创建实例' },
              component: VoteCreate
            },
            {
              path: 'update/:appId',
              name: 'vote-update',
              meta: { label: '修改实例' },
              component: VoteUpdate
            },
            {
              path: 'item/:appId',
              name: 'vote-item',
              meta: { label: '配置投票项' },
              component: VoteItem
            },
            {
              path: 'item/:appId/create',
              name: 'vote-item-create',
              meta: { label: '创建投票项' },
              component: VoteItemCreate
            },
            {
              path: 'item/:appId/update/:itemId',
              name: 'vote-item-update',
              meta: { label: '修改投票项' },
              component: VoteItemUpdate
            },
            {
              path: 'reward/:appId',
              name: 'vote-reward',
              meta: { label: '配置奖励' },
              component: VoteReward
            },
            {
              path: 'rewardHistory',
              name: 'vote-reward-history',
              meta: { label: '用户奖励历史' },
              component: VoteRewardHistory
            }
          ]
        },
        {
          path: 'settingsWelcome',
          name: 'settings-welcome',
          meta: { label: '欢迎页配置' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'category',
              name: 'settings-welcome-category',
              meta: { label: '功能分类' },
              redirect: '/settingsWelcome/category/',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'welcome-category-list',
                  meta: { label: '分类列表' },
                  component: WelcomeCategory
                },
                {
                  path: 'create',
                  name: 'welcome-category-create',
                  meta: { label: '创建分类' },
                  component: WelcomeCategoryCreate
                },
                {
                  path: 'update/:categoryCode',
                  name: 'welcome-category-update',
                  meta: { label: '修改分类' },
                  component: WelcomeCategoryUpdate
                }
              ]
            },
            {
              path: 'service',
              name: 'settings-welcome-service',
              meta: { label: '服务' },
              redirect: '/settingsWelcome/service/',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'welcome-service-list',
                  meta: { label: '服务列表' },
                  component: WelcomeService
                },
                {
                  path: 'create',
                  name: 'welcome-service-create',
                  meta: { label: '创建服务' },
                  component: WelcomeServiceCreate
                },
                {
                  path: 'update/:serviceCode',
                  name: 'welcome-service-update',
                  meta: { label: '修改服务' },
                  component: WelcomeServiceUpdate
                },
                {
                  path: ':serviceCode/demo',
                  name: 'welcome-demo-list',
                  meta: { label: '样例列表' },
                  component: WelcomeDemo
                },
                {
                  path: ':serviceCode/demo/create',
                  name: 'welcome-demo-create',
                  meta: { label: '创建样例' },
                  component: WelcomeDemoCreate
                },
                {
                  path: ':serviceCode/demo/update/:demoCode',
                  name: 'welcome-demo-update',
                  meta: { label: '修改样例' },
                  component: WelcomeDemoUpdate
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js